import ConfigSidebar from "@/components/config_components/ConfigSidebar/ConfigSidebar.vue";
import ComplyonAiSidebar from "@/components/config_components/ComplyonAiSidebar/ComplyonAiSidebar.vue";
import { SIDEBAR_SECTIONS } from "@/components/config_components/ConfigSidebar/config_sidebar.js";
import navbar from "@/components/config_components/Navbar/NavBar.vue";

export default {
  name: 'ConfigsLayout',
  components: {
    ConfigSidebar,
    ComplyonAiSidebar,
    navbar
  },
  data: () => ({
    is_sidebar_hidden: false,
    show_backdrop: false,
    show_mobile_drawer: false,
    show_ai_sidebar: true,
    show_new_workflow_modal: false,
    show_search_palette: false,
    search_query: '',
    isLargeScreen: window.innerWidth >= 1200
  }),
  computed: {
    should_hide_sidebar() {
      const hidden_routes = ['/', '/login'];
      return Boolean(this.$route.meta?.hideSidebar) || hidden_routes.includes(this.$route.path);
    },
    search_palette_sections() {
      const query = this.search_query.trim().toLowerCase();

      return SIDEBAR_SECTIONS
        .map((section) => ({
          ...section,
          items: section.items.filter((item) => {
            if (!query) {
              return true;
            }

            return [section.label, item.label, item.route_name]
              .some((value) => String(value || '').toLowerCase().includes(query));
          })
        }))
        .filter((section) => section.items.length > 0);
    }
  },
  watch: {
    '$route.fullPath'() {
      this.close_mobile_sidebar();
      this.close_search_palette();

      if (this.should_hide_sidebar) {
        this.is_sidebar_hidden = false;
      }
    }
  },
  mounted() {
    this.handle_resize();
    window.addEventListener('resize', this.handle_resize);
    window.addEventListener('keydown', this.handle_global_keydown);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handle_resize);
    window.removeEventListener('keydown', this.handle_global_keydown);
    document.body.classList.remove('mobile-drawer-open');
    document.body.classList.remove('search-palette-open');
  },
  methods: {
    handle_resize() {
      this.isLargeScreen = window.innerWidth >= 1200;

      if (window.innerWidth >= 992) {
        this.close_mobile_sidebar();
      }
    },
    close_mobile_sidebar() {
      this.show_mobile_drawer = false;
      document.body.classList.remove('mobile-drawer-open');
    },
    toggle_sidebar() {
      this.show_mobile_drawer = !this.show_mobile_drawer;
      document.body.classList.toggle('mobile-drawer-open', this.show_mobile_drawer);
    },
    toggle_ai_sidebar() {
      this.show_ai_sidebar = !this.show_ai_sidebar;
    },
    open_search_palette() {
      this.show_search_palette = true;
      this.search_query = '';
      document.body.classList.add('search-palette-open');

      this.$nextTick(() => {
        const input = this.$refs.searchPaletteInput;

        if (input?.focus) {
          input.focus();
        }
      });
    },
    close_search_palette() {
      this.show_search_palette = false;
      this.search_query = '';
      document.body.classList.remove('search-palette-open');
    },
    handle_global_keydown(event) {
      if (event.key === 'Escape' && this.show_search_palette) {
        this.close_search_palette();
      }
    },
    go_to_palette_route(route_name) {
      if (!route_name) {
        return;
      }

      this.close_search_palette();
      this.$router.push({ name: route_name });
    },
    open_new_workflow_modal() {
      this.show_new_workflow_modal = true;
    },
    close_new_workflow_modal() {
      this.show_new_workflow_modal = false;
    }
  }
}
